import { render, staticRenderFns } from "./AddClientStatusType.vue?vue&type=template&id=d0247a3c&"
import script from "./AddClientStatusType.vue?vue&type=script&lang=js&"
export * from "./AddClientStatusType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports